
import { defineComponent } from 'vue';
import { i18n } from '@tencent/vb-web-base';
export default defineComponent({
  name: 'LangVue',
  components: {},
  setup() {
    const isEng = i18n.getLang() === 'en-GB';
    return {
      isEng,
    };
  },
});
